import { styled } from '@mui/material/styles';
import { Stack, Button, Avatar, Typography } from '@mui/material';

export const ButtonsContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[1],
  width: '320px',
  maxWidth: '100%',
  boxSizing: 'border-box',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0.75),
    width: '100%',
    maxWidth: '320px',
  },
  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(0.5),
  },
}));

export const ContactRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0.5),
  },
}));

export const ContactAvatar = styled(Avatar)(({ theme }) => ({
  width: '32px',
  height: '32px',
  [theme.breakpoints.down('sm')]: {
    width: '24px',
    height: '24px',
  },
}));

export const ContactButton = styled(Button)(({ theme }) => ({
  fontSize: '0.9rem',
  padding: theme.spacing(0.5, 1),
  minWidth: 'auto',
  justifyContent: 'flex-start',
  gap: theme.spacing(1),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.8rem',
    padding: theme.spacing(0.25, 0.5),
    gap: theme.spacing(0.5),
  },
  [theme.breakpoints.down('xs')]: {
    fontSize: '0.75rem',
  },
  '&.Mui-disabled': {
    opacity: 1,
    color: theme.palette.text.primary,
    cursor: 'default',
  },
}));

export const PanelHeader = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  textAlign: 'center',
  width: '100%',
  marginBottom: theme.spacing(1.5),
}));
